import { render } from "./NutritionPopup.vue?vue&type=template&id=fb8e92b8&scoped=true"
import script from "./NutritionPopup.vue?vue&type=script&lang=js"
export * from "./NutritionPopup.vue?vue&type=script&lang=js"

import "./NutritionPopup.vue?vue&type=style&index=0&id=fb8e92b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb8e92b8"

export default script